import { defaultTheme, ToastTheme } from '@medly-components/theme';

import colors from './colors';

export const toast: ToastTheme = {
    ...defaultTheme.toast,
    textColor: colors.darkBlue,
    bgColor: {
        ...defaultTheme.toast.bgColor,
        error: colors.errorBackground
    },
    fillColor: {
        ...defaultTheme.toast.fillColor,
        error: colors.error
    }
};
